export const getClientConfig = () => {
  const configObj = import(
    `./client-assets-config/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/client-config`
  ).then((module) => {
    return module.default;
  });
  return configObj;
};

export const createNewInstanceForStringConstants = () => {
  const StringConstant = import(
    `./client-assets-config/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/string-constants`
  ).then((module) => {
    return module.default;
  });
  return StringConstant;
};
export const createNewInstanceForAssets = () => {
  const StringConstant = import(
    `./client-assets-config/${process.env.NEXT_PUBLIC_PROJECT_CODE_ASSET}/client-assets`
  ).then((module) => {
    return module.default;
  });
  return StringConstant;
};
